import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput"]

  submit(event) {
    const form = this.element.closest('form') || this.element
    const input = event?.target

    // If triggered by search clear (empty input), handle specially
    if (input && input.type === 'search' && input.value === '') {
      this.clearSearch(input, form)
      return
    }

    // Normal submit for non-empty values
    if (form.requestSubmit) {
      form.requestSubmit()
    } else if (form.submit) {
      form.submit()
    }
  }

  // Called on input event - checks if search was cleared via X button
  checkClear(event) {
    const input = event.target
    // Detect clear: input is empty AND either we tracked a value OR URL has the filter param
    const inputName = input.name.match(/^f\[(.+)\]$/)
    const urlHasParam = inputName && new URL(window.location).searchParams.has(input.name)

    if (input.type === 'search' && input.value === '' && (this.hadValue || urlHasParam)) {
      const form = this.element.closest('form') || this.element
      this.clearSearch(input, form)
    }
    this.hadValue = input.value !== ''
  }

  connect() {
    // Track if input had a value (to detect clearing)
    this.hadValue = false
    if (this.hasSearchInputTarget) {
      this.hadValue = this.searchInputTarget.value !== ''
    } else {
      // Fallback: check for any search input in the element
      const searchInput = this.element.querySelector('input[type="search"]')
      if (searchInput) {
        this.hadValue = searchInput.value !== ''
      }
    }
  }

  clearSearch(input, form) {
    const url = new URL(form.action || window.location.pathname, window.location.origin)

    // Collect form data, excluding empty inputs
    const formData = new FormData(form)
    formData.forEach((value, key) => {
      if (value && value !== '') {
        url.searchParams.set(key, value)
      }
    })

    // A clean URL means "restore the server preference", so send an explicit
    // empty filter set when clearing the final active filter.
    const hasFilters = Array.from(url.searchParams.keys()).some(key => key.startsWith("f["))
    if (!hasFilters) {
      url.searchParams.set("f", "")
    }

    Turbo.visit(url.toString(), { action: "replace" })
  }
}
